import { gitWriteLockSelector } from "containers/Resources/Resources.selectors";
import { RecordType } from "graphql/generated/graphql";
import { useMemo } from "react";
import { useSelector } from "react-redux";

export interface GitWriteLock {
    state: "WRITE_WAIT" | "WRITE_START" | "WRITE_SUCCEEDED" | "WRITE_FAILED";
    record: {
        type: RecordType;
        id: string;
    };
    lockfile: string;
    exception?: { title: string; message: string };
}

interface GitLockData {
    [id: string]: GitWriteLock;
}

export const useGitWriteLock = () => {
    const gitWriteLock: GitWriteLock[] = useSelector(gitWriteLockSelector);

    const currentGitLockData = useMemo(
        () =>
            gitWriteLock.reduceRight((acc: GitLockData, currentGitLock: GitWriteLock) => {
                const currentId = currentGitLock.record.id;
                if (!acc[currentId]) {
                    acc[currentId] = currentGitLock;
                }
                return acc;
            }, {}),
        [gitWriteLock]
    );

    return currentGitLockData;
};
